/**
 * FolkloreContainer
 * 
 * Beautiful, resizable container component with folklore-inspired styling
 * Rewritten from scratch with proper border-radius handling
 */

import React from 'react';
import './FolkloreContainer.css';

export interface FolkloreContainerProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'stat' | 'image' | 'story' | 'dice';
  title?: string;
  minWidth?: string;
  maxWidth?: string;
  minHeight?: string;
  maxHeight?: string;
  padding?: string;
}

export const FolkloreContainer: React.FC<FolkloreContainerProps> = ({
  children,
  className = '',
  variant = 'default',
  title,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  padding,
}) => {
  const containerClass = `folklore-container folklore-container--${variant} ${className}`.trim();
  
  // Build inline styles for custom sizing
  const customStyle: React.CSSProperties = {
    ...(minWidth && { minWidth }),
    ...(maxWidth && { maxWidth }),
    ...(minHeight && { minHeight }),
    ...(maxHeight && { maxHeight }),
    ...(padding && { padding }),
  };

  // Apply parchment background
  const containerStyle: React.CSSProperties = {
    ...customStyle,
    backgroundImage: `url('/assets/backgrounds/parchment_Dan.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  return (
    <div className={`folklore-container-wrapper folklore-container-wrapper--${variant}`}>
      <div className={containerClass} style={containerStyle}>
        {title && (
          <div className="folklore-container__title">
            {title}
          </div>
        )}
        <div className="folklore-container__content">
          {children}
        </div>
      </div>
    </div>
  );
};

